export const TIV_SOURCE = {
    ICO: 'ICO',
    INFO_DRIVER: 'INFODRIVER',
    SITEDRIVER: 'SD'
};
